// Lista completa de timeframes del selector de chart — única fuente de
// verdad para TimeframeSelector.jsx, usada por ChartPage.jsx (privado) y
// ChartPublicPage.jsx (público) para que ambos ofrezcan exactamente los
// mismos timeframes. Los hooks de datos (useChartData.js/usePublicChartData.js)
// mantienen su propia copia con "seconds" (cuánto histórico pedir por
// timeframe) porque es un detalle de caché de cada hook, no de la UI.
export const TIMEFRAMES = [
  { label: '1m',  value: '1m' },
  { label: '5m',  value: '5m' },
  { label: '10m', value: '10m' },
  { label: '15m', value: '15m' },
  { label: '30m', value: '30m' },
  { label: '1h',  value: '1h' },
  { label: '2h',  value: '2h' },
  { label: '4h',  value: '4h' },
  { label: '1D',  value: '1d' },
  { label: '1S',  value: '1w' },
  { label: '1M',  value: '1M' },
]
